import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EnvironmentCheckComponent } from './components/environment-check.component';
import { EnvironmentCheckPipe } from './pipes/environment-check.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [EnvironmentCheckComponent, EnvironmentCheckPipe],
  exports: [EnvironmentCheckComponent, EnvironmentCheckPipe],
})
export class EnvironmentCheckModule {}
